import { FileUploader} from 'carbon-components-react';
import React from 'react';
import { useFormContext } from 'react-hook-form';


const FormFileUploader = ({name, label, buttonLabel, labelDescription, accept, onChange, onDelete, disabled}) => {
    const {register, setValue, trigger,formState} = useFormContext();

    let obj = formState.errors[name];

    const array = name.substr(0, name.indexOf("["));
    if(array.length > 0){
        const optionalName = name.replace('.', '?.');
        obj = formState.errors[array] ? eval(`formState.errors.${optionalName}`) : null;
    }

    const change = (e) => {
        console.log("UPLOADER CHANGE", e.target.files[0].name);
        if(onChange)
            onChange(e);
        if(e)
            setValue(name, e.target.files[0].name);
            
        trigger(name);
     
    }

    const deleted = (e) => {
        if(onDelete)
            onDelete();
        setValue(name, null);
        trigger(name);
    }

    return (  
        <div className='mt-4 ml-4'>
            <FileUploader
                name = {name} {...register(name)}
                accept = {accept}
                buttonKind = "primary"
                buttonLabel = {buttonLabel}
                filenameStatus = "edit"
                iconDescription = "Clear file"
                labelDescription = {labelDescription}
                labelTitle = {label}
                onChange = {change}
                onDelete = {deleted}
                id={name}
                disabled={disabled}
            />
        {!!obj ? <div className='text-danger mb-2'>{obj?.message}</div> :<></>}
        </div>
    );
}
 
export default FormFileUploader;